import { ReferenceType, ContentfulType } from '../../types/references'

const targetTypes = [ContentfulType.ImageInsert, 'ContentfulAsset']

export const getImageURLsFromReferences = (refs: ReferenceType[]): string[] => {
  const urls = refs
    .filter((ref) => targetTypes.includes(ref.__typename))
    .flatMap((ref) => {
      switch (ref.__typename) {
        case 'ContentfulImageInsert':
          return ref.images.map((img) => `https:${img.file.url}`)
        case 'ContentfulAsset':
          return `https:${ref.file.url}`
        default:
          return null
      }
    })
    .filter((url): url is string => Boolean(url))

  return urls
}
